import PropTypes from 'prop-types'

/**
 * @typedef {string} Id
 */
export const idPropType = PropTypes.string
